<template>
  <div id='contact-overlay' :class="{'active': active}">
    <a href="#" @click.prevent="closeContact()" class="closeBtn"><img class="close-btn" src="../assets/times-bk.png"></a>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import $ from 'jquery'
export default {
  mounted () {
    $('document').ready(() => {
      $('#contact-overlay').append(contactForm)
    })
  },
  methods: {
    ...mapActions({
      closeContact: 'closeContact'
    })
  },
  computed: {
    ...mapState({
      active: state => state.contactActive
    })
  }
}
</script>
<style scoped>
  #contact-overlay {
    opacity:0;
    visibility: hidden;
    z-index:15;
    position:absolute;
    width:100%;
    height:calc(100% - 60px);
    background:rgba(255,255,255,1);
    overflow-y:scroll;
    top:0;
    left:0;
    right: 0;
    bottom: 60px;
  }
  #contact-overlay.active {
    opacity:1;
    visibility: visible;
    z-index: 9999;
  }

  @media (max-width : 769px) {
    #contact-overlay {
      z-index: 50;
    }
  }
  @media (max-width : 769px) and (orientation: landscape) {
    #contact-overlay {
      height:calc(100% - 35px);
    }
  }
</style>
<style>
  .closeBtn {
    position:absolute;
    right:20px;
    top: 20px;
  }
  .closeBtn .close-btn {
    width:32px;
  }
  .gform_wrapper, .gform_confirmation_wrapper {
    margin:6em auto 0;
    max-width:600px;
    color:#043969;
  }
  .gform_wrapper h3 {
    text-align:center;
    font-size:2em;
    font-weight:200;
  }
  .gform_description {
    display:block;
    margin-bottom:1.5em;
  }
  ul.gform_fields {
    margin:0;
    padding:0;
  }
  ul.gform_fields li {
    margin:0 0 1em;
    padding:0;
    list-style-type:none;
  }
  #submit-overlay label {
    display:none;
  }
  #field_1_5 label {
    display:inline;
  }
  input, select, textarea {
    width:100%;
  }
  input[type="text"],
  input[type="email"],
  textarea,
  select {
    font-size: 1.125em;
    padding: .5em;
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid #ccc;
    color:#aaa;
    -webkit-input-placeholder:#ccc;
    -moz-placeholder:#ccc;
    -ms-input-placeholder:#ccc;
  }
  textarea {
    border:1px solid #ccc;
    height:7em;
  }
  input[type="submit"] {
    font-size: 1.5em;
    background: #043969;
    border: none;
    color: #fff;
    padding: .75em 0;
    cursor:pointer;
  }
  input[type="submit"]:hover {
    background: #032748;
  }
  #field_1_5 input {
    width:auto;
  }
  .gform_wrapper .gform_fileupload_multifile .gform_drop_area {
    padding: 24px;
    border: 1px dashed #CCC;
    text-align: center;
    color: #AAA;
    margin-bottom: 16px;
    background: rgba(0,0,0,.02);
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
  }
  .gform_wrapper span.gform_drop_instructions {
    display: block;
    margin-bottom: 8px;
  }
  .gform_wrapper.gf_browser_chrome input.button.gform_button_select_files {
    padding: 6px 12px!important;
  }

  @media (max-width : 700px) {
    .gform_wrapper, .gform_confirmation_wrapper {
      padding:0 25px;
      box-sizing:border-box;
    }
  }
</style>



// WEBPACK FOOTER //
// Contact.vue?7521110e